import { Route, Routes } from 'react-router-dom';

import BuyNowWithDiscount from 'components/Trials/ModalView/BuyNowWithDiscount/BuyNowWithDiscountComponent';
import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

import {
  CheckoutPageProtectedRoute,
  CheckoutPageWrapper,
} from './components/layout';
import {
  CONFIRM_VIEW_ROUTE,
  PAYMENT_VIEW_ROUTE,
  SELECT_PLAN_BASE_ROUTE,
  SUMMARY_VIEW_ROUTE,
  TRIAL_BUY_NOW_BASE_ROUTE,
  TRIAL_CHECKOUT_ROUTE,
} from './constants';
import PaymentConfirmationView from './PaymentConfirmationView';
import PaymentView from './PaymentView';
import PlanSummaryView from './PlanSummaryView';
import SelectPlanView from './SelectPlanView';

const SelectPlanCheckoutView = ({ closeCheckoutPage, isTrial }) => {
  const { hasCompletedPurchase, isMobile, redirectAfterPurchase } =
    useCheckoutContext();

  const closeCheckoutFlow = () =>
    hasCompletedPurchase
      ? redirectAfterPurchase && redirectAfterPurchase()
      : closeCheckoutPage && closeCheckoutPage();
  const selectPlanViewRouterProps = isTrial
    ? { path: TRIAL_CHECKOUT_ROUTE }
    : { index: true };
  const baseRoute = isTrial ? TRIAL_BUY_NOW_BASE_ROUTE : SELECT_PLAN_BASE_ROUTE;
  const protectedAfterPaymentStepProps = {
    baseRoute,
    isAfterPaymentStep: true,
  };

  return (
    <CheckoutPageWrapper
      closeCheckoutPage={closeCheckoutPage ? closeCheckoutFlow : null}
      isMobile={isMobile}
    >
      <Routes>
        {isTrial && <Route element={<BuyNowWithDiscount />} index />}
        <Route element={<SelectPlanView />} {...selectPlanViewRouterProps} />
        <Route
          element={
            <CheckoutPageProtectedRoute baseRoute={baseRoute}>
              <PaymentView />
            </CheckoutPageProtectedRoute>
          }
          path={PAYMENT_VIEW_ROUTE}
        />
        <Route
          element={
            <CheckoutPageProtectedRoute {...protectedAfterPaymentStepProps}>
              <PlanSummaryView />
            </CheckoutPageProtectedRoute>
          }
          path={SUMMARY_VIEW_ROUTE}
        />
        <Route
          element={
            <CheckoutPageProtectedRoute {...protectedAfterPaymentStepProps}>
              <PaymentConfirmationView />
            </CheckoutPageProtectedRoute>
          }
          path={CONFIRM_VIEW_ROUTE}
        />
      </Routes>
    </CheckoutPageWrapper>
  );
};

export default SelectPlanCheckoutView;
